/* tslint:disable */

declare var Object: any;
export interface StatsInterface {
  "id"?: number;
}

export class Stats implements StatsInterface {
  "id": number;
  constructor(data?: StatsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Stats`.
   */
  public static getModelName() {
    return "Stats";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Stats for dynamic purposes.
  **/
  public static factory(data: StatsInterface): Stats{
    return new Stats(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Stats',
      plural: 'stats',
      path: 'stats',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
